import PropTypes from 'prop-types';

export const coverage = (eventProducts) => {
    return eventProducts.map(element => element.short_name).join(', ');
};

coverage.propTypes = {
    products: PropTypes.object.isRequired,
};
